import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui';
// import 'element-ui/lib/theme-chalk/index.css';
import './assets/css/config.scss'
import './utils/flexible'
import { postRequest, getRequest, setRequest, baseUrl,websocket,getRequestaddress } from './api/http'
import util from "./utils/util.js";
import cookie from 'js-cookie'
import imagePreview from './components/imagePreview'
import imageUpload from './components/imageUpload'
import richText from './components/richText'
import * as Echarts from "echarts";
import * as directive from './utils/directive'
import {VueJsonp} from 'vue-jsonp';

Vue.use(VueJsonp);

Vue.component('imagePreview', imagePreview)
Vue.component('imageUpload', imageUpload)
Vue.component('richText', richText)
Vue.prototype.$echarts = Echarts
Vue.prototype.$util = util;
Vue.config.productionTip = false
Vue.prototype.$baseUrl = baseUrl
Vue.prototype.$websocket = websocket
Vue.prototype.$post = postRequest
Vue.prototype.$get = getRequest
Vue.prototype.$getAddress = getRequestaddress
Vue.prototype.$setRequest = setRequest
Vue.prototype.$size = 15
Vue.use(ElementUI);
Vue.prototype.$cookie = cookie
// 引入粒子特效
import VueParticles from "vue-particles"
Vue.use(VueParticles)
// main.js
import htmlToPdf from './utils/htmlToPdf'
Vue.use(htmlToPdf)


// 注册全局的指令
Object.keys(directive).forEach((key) => {
  Vue.directive(key, directive[key])
})
new Vue({
  router,
  render: h => h(App),
  data() {
    return {
      barflag: false,
      allNum: 1,
      goEasy: null,
      video: true
    }
  }
}).$mount('#app')
